function MenuAula3() {
  

    return (
      <>
        <nav>
            <ul>
              <li><a href="#O-que-é-SASS">O que é SASS</a></li>
              <li><a href="#Como-usar-o-SASS">Como usar o SASS</a></li>
              <li><a href="#SASS-variáveis">SASS variáveis</a></li>
              <li><a href="#SASS-Funções">SASS Funções</a></li>
              <li><a href="#SASS-Hierarquia">SASS Hierarquia</a></li>
              <li><a href="#SASS-Import-ou-@use">SASS Import ou @use</a></li>
              <li><a href="#SASS-Operadores-Matemáticos">SASS Operadores Matemáticos</a></li>
              <li><a href="#Operadores-matemáticos-exemplos-práticos">Operadores-matemáticos-exemplos-práticos</a></li>
              <li><a href="#Como-remover-as-aspas-de-uma-string">Como remover as aspas de uma string</a></li>
              <li><a href="#Repetição / For / Looping">Repetição / For / Looping</a></li>
              <li><a href="#Exercício 2">Exercício 2</a></li>
            </ul>
          </nav>
      </>
    );
  }
  
  export default MenuAula3;